/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoringTemplateTrackCurveUnit
 */
export interface MonitoringTemplateTrackCurveUnit {
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveUnit
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveUnit
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTemplateTrackCurveUnit
     */
    description?: string;
}

/**
 * Check if a given object implements the MonitoringTemplateTrackCurveUnit interface.
 */
export function instanceOfMonitoringTemplateTrackCurveUnit(value: object): value is MonitoringTemplateTrackCurveUnit {
    return true;
}

export function MonitoringTemplateTrackCurveUnitFromJSON(json: any): MonitoringTemplateTrackCurveUnit {
    return MonitoringTemplateTrackCurveUnitFromJSONTyped(json, false);
}

export function MonitoringTemplateTrackCurveUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTemplateTrackCurveUnit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function MonitoringTemplateTrackCurveUnitToJSON(value?: MonitoringTemplateTrackCurveUnit | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

